"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
function PuppyGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="h-[450px] animate-pulse rounded-xl border-secondary shadow-sm shadow-primary/10" />)}
        </div>
      </div>;
  }
  if (error) {
    return <div className="mx-auto max-w-7xl px-4 text-center text-sm text-destructive sm:px-6 lg:px-8">
        Failed to load puppy listings. Please try again later.
      </div>;
  }
  if (posts.length === 0) {
    return <div className="mx-auto flex max-w-3xl flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <p className="mb-8 font-serif text-2xl italic text-muted-foreground">
          No puppies available
        </p>
        <Link to="#">
          <Button variant="outline" className="border-primary text-primary hover:bg-primary/5">
            Join our Waitlist
          </Button>
        </Link>
      </div>;
  }
  return <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post, i) => {
        const imageUrl = post.customFields?.picture || post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599074/img/generic_puppy_placeholder.png";
        const description = post.customFields?.description;
        const truncatedDescription = description ? description.length > 150 ? description.substring(0, 150) + "…" : description : null;
        return <Card key={post.id} data-index={i} className="flex h-full flex-col overflow-hidden rounded-xl border-secondary shadow-sm shadow-primary/20 transition-shadow hover:shadow-md hover:shadow-primary/20">
              <img src={imageUrl} alt={post.title} className="h-72 w-full object-cover" />
              <CardContent className="flex flex-grow flex-col items-center px-6 pb-8 pt-6 text-center">
                <h3 className="font-serif text-2xl font-semibold text-foreground">
                  {post.title}
                </h3>
                {truncatedDescription && <p className="mt-3 font-sans text-sm text-muted-foreground">
                    {truncatedDescription}
                  </p>}
                {post.customFields?.pedigree && <p className="mt-3 line-clamp-3 font-sans text-sm text-muted-foreground italic">
                    {post.customFields.pedigree}
                  </p>}
                <div className="mt-auto pt-8">
                  <Link to={post.link || "#"}>
                    <Button variant="outline" className="border-secondary text-primary hover:bg-secondary/20">
                      View Details
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>;
      })}
      </div>
    </div>;
}
export default function PuppyListings() {
  const wp_query_params = {
    post_type: "puppy",
    per_page: 100,
    orderby: "date",
    order: "desc",
    include: []
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}